import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { CartillaTable } from './CartillaTable';
import { contratacionesCartillaPrestadoresSave } from '../../../actions/contrataciones/contratacionesCartilla';
import { DialogContent, DialogTitle } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { CartillaForm } from './CartillaForm';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    buttonContainer: {
        marginTop: 15,
        marginBottom: 15,
        marginLeft: "auto",
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function CartillaPrestadoresButton({ idPrestador, cartillaPrestadores, disabled }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    return (
        <div>
            <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={handleClickOpen}
            >
                Ver Cartilla
            </Button>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Cartilla de Prestadores
                        </Typography>
                    </Toolbar>
                </AppBar>
                {
                    !disabled &&
                    <div className={classes.buttonContainer}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={handleOpenModal}
                        >
                            + Agregar item cartilla
                        </Button>
                    </div>
                }
                <div>
                    <CartillaTable cartillaPrestadores={cartillaPrestadores} disabled={disabled} />
                </div>
                {
                    openModal && (
                        <Dialog
                            open={openModal}
                            onClose={handleCloseModal}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                            fullWidth
                            maxWidth="md"
                        >
                            <DialogTitle id="alert-dialog-slide-title">
                                {"Agregar Item Cartilla"}
                            </DialogTitle>
                            <DialogContent>
                                <CartillaForm formData={null} handleSubmit={(data) => {
                                    data.idPrestador = idPrestador
                                    dispatch(contratacionesCartillaPrestadoresSave(data)).then((e) => {
                                        handleCloseModal()
                                    }).catch((e) => { })
                                }} handleCloseModal={handleCloseModal} />
                            </DialogContent>
                        </Dialog>
                    )
                }

            </Dialog>
        </div>
    );
}